export default __webpack_public_path__ + "static/media/SignedSealedDeliverd.84a58572.svg";